import common from "../../common";
import QuestionViewStatement from "./QuestionViewStatement";

export default class QuestionViewStatementAlgebra extends QuestionViewStatement {
    constructor(question) {
        super(question);
    }

    getHeaderText() {
        const data = P3.assets.json("templates");
        const name = data.template ? data.template : this._question.module;
        let templates = data["templates"][name]["single_unknown"];//todo - we need a template type in the question

        if (templates) {
            templates = templates.slice().filter(x => this.filterTemplate(x));
        }

        if (!templates || !templates.length) return "ERROR: NO TEMPLATE FOUND";

        this._template = P3.utils.selectRandom(templates);

        const words = data.words;

        const locations = this.generateWords(this._template.text, words.specific_locations, /\[SPECIFIC_LOCATION([0-9])?]/g);
        for (const i in locations) {
            if (locations.hasOwnProperty(i)) {
                this._template.text = this._template.text.replace(new RegExp(P3.utils.escape(i), "g"), locations[i]);
            }
        }
        console.log(locations);

        //  const text = this._template.text;
        let result = this._template.text.match(/\[VAR([0-9])?]/g);
        if (result) {
            return this._template.text.replace(result[0], this._question.answer.unknownCharacter);
        }

        return this._template.text;
    }

    createStatement() {
        let width = 0;

        const spacing = 15;

        const operands = this._question.operands;

        for (let i = 0, j = 0; i < this._question.values.length; ++i) {
            const value = this._question.values[i];

            const label = this.createLabel(value.toString(false));
            label.position.set(width, 0);
            this._footer.statement.addChild(label);

            if (i < this._question.values.length - 1) {
                width += label.width + spacing;
            }

            // add operand
            const labelOp = this.createLabel(operands[j++]);
            labelOp.position.set(width, 0);
            this._footer.statement.addChild(labelOp);

            i < this._question.values.length - 1 && (width += labelOp.width + spacing);
        }

       // this._inputField.position.set(0, -100);
        this._footer.addChild(this._inputField);

        // center statement
        this._footer.statement.pivot.x = width * 0.5;
    }

    generateWords(text, options, regex) {
        const words = {};
        options = options.slice();

        let result = text.match(regex);
        if (result) {
            for (let i = 0; i < result.length; ++i) {
                const t = result[i];
                const name = P3.utils.selectRandom(options);
                !words[t] && (words[t] = name);
                options.splice(options.indexOf(name), 1);
            }
        }
        return words;
    }

    filterTemplate(x) {
        return x.allow_q_mark === this._question.hasQuestionMark;
    }

    isCorrect() {
        return parseInt(this._inputValue.value) === parseInt(this._question.answer.variable);
    }
}